import React from 'react';
import { useSelector } from 'react-redux';
import { css } from '@emotion/core';
import i18n from 'i18next';
import Button from 'Mui/Button';

import useLoginUrl from 'client/hooks/login/useLoginUrl';
import useLoginLinkClickAction from 'client/hooks/login/useLoginLinkAction';
import usePromoSettingThemeStyle from 'hooks/useThemeStyleIntegration';
import { loginTypesForApi } from 'config/loginTypes';
import { system300 } from 'Mui/styles/color';
import { themedButtonStyle } from 'styles/common';

function LoginEnterprise() {
    const themeStyle = usePromoSettingThemeStyle();
    const { enableRestrictToAppLogin } = useSelector(s => s.settingPromo);
    const {
        enterpriseAppDeepLink: sponsorEnterpriseAppDeepLink = '',
        enterpriseCanAppendUrlToDeepLink: sponsorEnterpriseCanAppendUrlToDeepLink = 'false'
    } = useSelector(s => s.sponsor);
    const {
        enterpriseAppDeepLink: partnerEnterpriseAppDeepLink = '',
        enterpriseCanAppendUrlToDeepLink: partnerEnterpriseCanAppendUrlToDeepLink = 'false'
    } = useSelector(s => s.partner);
    const enterpriseAppDeepLink = sponsorEnterpriseAppDeepLink || partnerEnterpriseAppDeepLink;
    const enterpriseCanAppendUrlToDeepLink =
        JSON.parse(sponsorEnterpriseCanAppendUrlToDeepLink) ||
        JSON.parse(partnerEnterpriseCanAppendUrlToDeepLink);
    const loginUrl = useLoginUrl({ loginType: loginTypesForApi.ENTERPRISE });
    const deepLinkUrl = (() => {
        if (Boolean(enterpriseAppDeepLink.length)) {
            if (enterpriseCanAppendUrlToDeepLink) {
                const url = new URL(enterpriseAppDeepLink);
                const qs = new URLSearchParams(url.search);
                let qsIndex = 1;
                for (let [key, value] of qs.entries()) {
                    const isLastQs = qsIndex === [...qs].length;
                    //  [86enfp4qd] deep link 最後一個 query string 沒有設定值，就補上我們的活動 url
                    if (isLastQs && !Boolean(value)) {
                        qs.set(key, encodeURIComponent(window.location.href));
                        url.search = qs;
                    }
                    qsIndex++;
                }
                return url.toString();
            }
            return enterpriseAppDeepLink;
        }
        return '';
    })();

    const buttonUrl = enableRestrictToAppLogin ? deepLinkUrl : loginUrl;
    const { target, href, onClick } = useLoginLinkClickAction({ loginUrl: buttonUrl });

    return (
        <a href={href} target={target} onClick={onClick} css={linkStyle}>
            <Button
                css={[
                    buttonStyle,
                    enableRestrictToAppLogin && themedButtonStyle(themeStyle.buttonBgColor)
                ]}
            >
                {enableRestrictToAppLogin
                    ? i18n.t('label.login.app')
                    : i18n.t('label.login.enterprise')}
            </Button>
        </a>
    );
}

export default LoginEnterprise;

const buttonStyle = css`
    color: #fff;
    border-radius: 20px;
    background-color: #0066ff;
    padding: 6px 12.5px;
    font-weight: bold;
    min-width: 125px;
    &:hover {
        background-color: #0066ff;
    }
    &.Mui-disabled {
        background-color: ${system300.color};
        color: #fff;
    }
`;

const linkStyle = css`
    text-decoration: none;
`;
